import { Create, SimpleForm, TextInput } from 'react-admin';
import { CustomTitle } from '../../components/CustomTitle';

const initialValues = {
  title: '',
};
export const PathCreate = (props: unknown) => (
  <Create {...props} title={<CustomTitle />}>
    <SimpleForm redirect={false} defaultValues={initialValues}>
      <TextInput source="title" />
    </SimpleForm>
  </Create>
);
